import { render } from "./InputBasic.vue?vue&type=template&id=0cf980c9&scoped=true"
import script from "./InputBasic.vue?vue&type=script&lang=js"
export * from "./InputBasic.vue?vue&type=script&lang=js"

import "./InputBasic.vue?vue&type=style&index=0&id=0cf980c9&scoped=true&lang=css"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cf980c9"]])

export default __exports__